export default "__VITE_ASSET__DPaQx4IL__"